import React from 'react';
import PropTypes from 'prop-types';
import { Image } from 'react-bootstrap-5';
import IntegrationModal from './integration_modal';

import calendarIcon from '../images/calendar_integration.svg';
export default class CancelCalendarModal extends React.Component {

  static propTypes = {
    shown: PropTypes.bool,
    onCancel: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired
  };

  handleSave = () => {
    const { onSave } = this.props;
    return onSave('calendar');
  }

  render() {
    const { shown, onCancel } = this.props;

    return (
      <IntegrationModal
        disconnectModal
        shown={shown}
        title="Disconnect Your Calendar Sync"
        onCancel={onCancel}
        onSave={this.handleSave}
      >
        <div className="text-center">
          <div className="mb-3">
            <div className="bg-body-tertiary border rounded p-2 d-inline-flex">
              <Image alt="Calendar integration" height={40} src={calendarIcon} width={40}/>
            </div>
          </div>
          <span className="text-muted">
            Your meetings and calendar events will no longer sync with your Connected Calendar.
          </span>
        </div>
      </IntegrationModal>
    );
  }
}
